/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {AppEventBusService} from '../common/events/app-event-bus.service';

import {Api404ContextService} from './api-404-context.service';
import template from './api404-page.component.html';
import {NetworkResource} from '../../components/api/resources/resource/network.resource';
import {AdnNetworkHelperService} from '../../components/util/adn-network-helper.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {BrowserLocationService} from '../angular-platform-providers';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-api404-page',
  template
})
export class Api404PageComponent implements OnInit {
  errorType = 'default';
  url = '';
  objectId: string;
  username: string;
  hasOtherNetworks = false;
  allChecked = false;
  networks: any[] | null = null;

  constructor(
    private readonly eventBus: AppEventBusService,
    private readonly $state: StateService,
    @Inject(BrowserLocationService) private readonly location: any,
    private readonly Api404Context: Api404ContextService,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserProfile) private readonly localUserProfile: any,
    @Inject(AdnNetworkHelperService) private readonly adnNetworkHelper: any,
    @Inject(NetworkResource) private readonly Network: any
  ) {
  }

  ngOnInit(): void {
    const rejection = this.Api404Context.consumeRejection(null);
    this.url = _.get(rejection, ['config', 'url'], this.location.pathname);

    if (!rejection || !rejection.data) {
      return;
    }

    if (rejection.data.code === 'error.object.not.found') {
      this.errorType = 'objectNotFound';
      this.objectId = this.getObjectId(this.url);
      this.username = this.location.queryParams.username;

      const networkTagIds = _.filter(this.localUserProfile.get('networkTagIds'), (networkTagId: string) => {
        return networkTagId !== _.get(rejection, ['config', 'params', 'context']);
      });
      this.hasOtherNetworks = networkTagIds.length > 0;
      this.allChecked = networkTagIds.length < 2 || false;

      const currentNetworkId = this.LocalNetworkProfile.getNetworkId();
      this.Network.query(_.isString(this.username) ? {username: this.username} : {object: this.objectId},
        (data: any) => {
          this.networks = _.filter(data.results, (n: any) => n.id !== currentNetworkId);
          this.allChecked = true;
        },
        () => {
          this.networks = null;
          this.allChecked = true;
        });
    } else {
      this.errorType = 'default';
    }
  }

  switchNetwork(network: any): void {
    const ctrl: any = {};
    this.adnNetworkHelper.switchNetwork(ctrl, this.eventBus, network);
    if (this.username) {
      this.$state.go('app.adm.users');
    }
  }

  private getObjectId(url: string): string {
    const splitArray = url.split('/');
    return splitArray[splitArray.length - 1];
  }
}
